import type { Role } from '../../lib/sessionContext';

export interface NavItem {
  to: string;
  label: string;
  /** Roles que ven la entrada; espejo de la matriz de qr-api (qrcl/core/authz.py). Sin valor = todos. */
  roles?: Role[];
}

const MANAGERS: Role[] = ['owner', 'admin'];

export const consoleNav: NavItem[] = [
  { to: '/consola/inventario', label: 'Inventario' },
  { to: '/consola/lotes', label: 'Lotes', roles: MANAGERS },
  { to: '/consola/qr', label: 'QR activados' },
  { to: '/consola/miembros', label: 'Miembros', roles: MANAGERS },
  { to: '/consola/api-keys', label: 'API keys', roles: MANAGERS },
  { to: '/consola/auditoria', label: 'Auditoría', roles: MANAGERS },
  { to: '/consola/pagina', label: 'Página del partner', roles: MANAGERS },
];

export const operatorNav: NavItem[] = [
  { to: '/operador/organizaciones', label: 'Organizaciones' },
  { to: '/operador/qr', label: 'QR' },
  { to: '/operador/dominios', label: 'Dominios y reservados' },
  { to: '/operador/migracion', label: 'Migración' },
  { to: '/operador/configuracion', label: 'Configuración' },
];

export function visibleNav(items: NavItem[], role: Role | undefined): NavItem[] {
  return items.filter((item) => !item.roles || (role !== undefined && item.roles.includes(role)));
}
